//const ajaxPath = "http://localhost/vpservices/ajax_query.php";
const ajaxPath = "https://www.vetsnz.ru/vpservices/ajax_query.php";
export {ajaxPath};